import { render } from "./SelectGiftModal.vue?vue&type=template&id=1bca593c&scoped=true&lang=pug"
import script from "./SelectGiftModal.vue?vue&type=script&lang=js"
export * from "./SelectGiftModal.vue?vue&type=script&lang=js"

import "./SelectGiftModal.vue?vue&type=style&index=0&id=1bca593c&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bca593c"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QLinearProgress,QScrollArea,QTooltip,QSeparator,QBtn});
